// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectThread-thread-lGPhN {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --teal: #0f766e;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
  border: 1px solid #e7e9ec;
  border: 1px solid var(--line);
  border-radius: 18px;
  -webkit-box-shadow: 0 8px 30px rgba(15, 18, 20, 0.06);
          box-shadow: 0 8px 30px rgba(15, 18, 20, 0.06);
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  max-height: 640px;
}

/* HEADER */

.ProjectThread-head-XGv73 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.ProjectThread-backBtn-DDKHg {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--muted);
  border-radius: 10px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.ProjectThread-backBtn-DDKHg:hover { border-color: var(--red); color: var(--red); }

.ProjectThread-backBtn-DDKHg svg { width: 16px; height: 16px; }

.ProjectThread-headMain-xFUN5 { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 12px; }

.ProjectThread-headAvatar-pP7j1 {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.ProjectThread-headAvatar-pP7j1 svg { width: 22px; height: 22px; }

.ProjectThread-headName-mgSG7 { display: block; font-weight: 700; font-size: 15px; }

.ProjectThread-headProject-C04G1 { display: block; font-size: 12px; color: var(--muted); margin-top: 2px; }

/* SAFETY NOTE */

.ProjectThread-safetyNote-_p5G8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #f0fdfa;
  color: var(--teal);
  font-size: 12.5px;
  font-weight: 500;
  border-bottom: 1px solid var(--line);
}

.ProjectThread-safetyNote-_p5G8 svg { width: 16px; height: 16px; -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; }

/* MESSAGE LIST */

.ProjectThread-list-cl2UP {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  overflow-y: auto;
  padding: 18px 20px;
  background: var(--bg);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
  min-height: 220px;
}

.ProjectThread-loading-hwvZf, .ProjectThread-emptyMsg-KXaCk {
  margin: auto;
  text-align: center;
  color: var(--muted);
  font-size: 14px;
}

.ProjectThread-emptyMsg-KXaCk p { margin: 0; }

.ProjectThread-emptyMsgSub-LMi9s { margin-top: 6px; font-size: 13px; }

.ProjectThread-row-RxLW1 { display: -webkit-box; display: -ms-flexbox; display: flex; }

.ProjectThread-rowMine-KxqzK { -webkit-box-pack: end; -ms-flex-pack: end; justify-content: flex-end; }

.ProjectThread-rowTheirs-yWz9q { -webkit-box-pack: start; -ms-flex-pack: start; justify-content: flex-start; }

.ProjectThread-bubble-EK07m {
  max-width: 76%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.45;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
  word-break: break-word;
  white-space: pre-wrap;
}

.ProjectThread-bubbleMine-NWYiy {
  background: var(--red);
  color: #fff;
  border-bottom-right-radius: 5px;
}

.ProjectThread-bubbleTheirs-O7xyq {
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  border-bottom-left-radius: 5px;
}

.ProjectThread-bubbleText-w7lbS { white-space: pre-wrap; }

.ProjectThread-bubbleTime-vukcZ {
  font-size: 11px;
  opacity: 0.7;
  -ms-flex-item-align: end;
      align-self: flex-end;
}

.ProjectThread-bubbleMine-NWYiy .ProjectThread-bubbleTime-vukcZ { color: #ffe5e5; }

.ProjectThread-bubbleTheirs-O7xyq .ProjectThread-bubbleTime-vukcZ { color: var(--muted); }

/* NOTES */

.ProjectThread-filteredNote-ovV9C {
  margin: 0 20px;
  padding: 8px 12px;
  background: #fff7ed;
  color: #9a3412;
  border-radius: 10px;
  font-size: 12.5px;
}

.ProjectThread-alertErr-0wzSo {
  margin: 10px 20px 0;
  padding: 10px 12px;
  background: #fef2f2;
  color: var(--red-d);
  border: 1px solid #fecaca;
  border-radius: 10px;
  font-size: 13px;
}

/* COMPOSER */

.ProjectThread-composer-eLQjb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--line);
  background: #fff;
}

.ProjectThread-composerInput-gtv9Y {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  resize: none;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 10px 14px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.45;
  color: var(--ink);
  outline: none;
}

.ProjectThread-composerInput-gtv9Y:focus { border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }

.ProjectThread-sendBtn-cvxdN {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 7px;
  border: none;
  background: var(--red);
  color: #fff;
  border-radius: 12px;
  padding: 11px 18px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.ProjectThread-sendBtn-cvxdN:hover { background: var(--red-d); }

.ProjectThread-sendBtn-cvxdN:disabled { opacity: 0.5; cursor: not-allowed; }

.ProjectThread-sendBtn-cvxdN svg { width: 18px; height: 18px; }
`, "",{"version":3,"sources":["webpack://./src/components/ProjectThread/ProjectThread.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAA6B;EAA7B,6BAA6B;EAC7B,mBAAmB;EACnB,qDAA6C;UAA7C,6CAA6C;EAC7C,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,WAAW;;AACX;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA,qCAAiB,wBAAwB,EAAE,iBAAiB,EAAE;;AAC9D,mCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,gCAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,SAAS,EAAE;;AAC3D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA,sCAAkB,WAAW,EAAE,YAAY,EAAE;;AAC7C,gCAAY,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAC/D,mCAAe,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAEtF,gBAAgB;;AAChB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AACA,sCAAkB,WAAW,EAAE,YAAY,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AAE7D,iBAAiB;;AACjB;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AACA,kCAAc,SAAS,EAAE;;AACzB,mCAAe,eAAe,EAAE,eAAe,EAAE;;AAEjD,2BAAO,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE;;AACtB,+BAAW,qBAAyB,EAAzB,kBAAyB,EAAzB,yBAAyB,EAAE;;AACtC,iCAAa,uBAA2B,EAA3B,oBAA2B,EAA3B,2BAA2B,EAAE;;AAE1C;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;AACvB;;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,+BAA+B;AACjC;;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;AAChC;;AACA,kCAAc,qBAAqB,EAAE;;AACrC;EACE,eAAe;EACf,YAAY;EACZ,wBAAoB;MAApB,oBAAoB;AACtB;;AACA,kEAA0B,cAAc,EAAE;;AAC1C,oEAA4B,mBAAmB,EAAE;;AAEjD,UAAU;;AACV;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,aAAa;;AACb;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AACA,2CAAuB,wBAAwB,EAAE,qDAA6C,EAA7C,6CAA6C,EAAE;;AAChG;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,qCAAiB,wBAAwB,EAAE;;AAC3C,wCAAoB,YAAY,EAAE,mBAAmB,EAAE;;AACvD,mCAAe,WAAW,EAAE,YAAY,EAAE","sourcesContent":[".thread {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --teal: #0f766e;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  box-shadow: 0 8px 30px rgba(15, 18, 20, 0.06);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 640px;\n}\n\n/* HEADER */\n.head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--line);\n  background: #fff;\n}\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--muted);\n  border-radius: 10px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.backBtn:hover { border-color: var(--red); color: var(--red); }\n.backBtn svg { width: 16px; height: 16px; }\n.headMain { display: flex; align-items: center; gap: 12px; }\n.headAvatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.headAvatar svg { width: 22px; height: 22px; }\n.headName { display: block; font-weight: 700; font-size: 15px; }\n.headProject { display: block; font-size: 12px; color: var(--muted); margin-top: 2px; }\n\n/* SAFETY NOTE */\n.safetyNote {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f0fdfa;\n  color: var(--teal);\n  font-size: 12.5px;\n  font-weight: 500;\n  border-bottom: 1px solid var(--line);\n}\n.safetyNote svg { width: 16px; height: 16px; flex: 0 0 auto; }\n\n/* MESSAGE LIST */\n.list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 18px 20px;\n  background: var(--bg);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 220px;\n}\n.loading, .emptyMsg {\n  margin: auto;\n  text-align: center;\n  color: var(--muted);\n  font-size: 14px;\n}\n.emptyMsg p { margin: 0; }\n.emptyMsgSub { margin-top: 6px; font-size: 13px; }\n\n.row { display: flex; }\n.rowMine { justify-content: flex-end; }\n.rowTheirs { justify-content: flex-start; }\n\n.bubble {\n  max-width: 76%;\n  padding: 10px 14px;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.45;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n.bubbleMine {\n  background: var(--red);\n  color: #fff;\n  border-bottom-right-radius: 5px;\n}\n.bubbleTheirs {\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n  border-bottom-left-radius: 5px;\n}\n.bubbleText { white-space: pre-wrap; }\n.bubbleTime {\n  font-size: 11px;\n  opacity: 0.7;\n  align-self: flex-end;\n}\n.bubbleMine .bubbleTime { color: #ffe5e5; }\n.bubbleTheirs .bubbleTime { color: var(--muted); }\n\n/* NOTES */\n.filteredNote {\n  margin: 0 20px;\n  padding: 8px 12px;\n  background: #fff7ed;\n  color: #9a3412;\n  border-radius: 10px;\n  font-size: 12.5px;\n}\n.alertErr {\n  margin: 10px 20px 0;\n  padding: 10px 12px;\n  background: #fef2f2;\n  color: var(--red-d);\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  font-size: 13px;\n}\n\n/* COMPOSER */\n.composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--line);\n  background: #fff;\n}\n.composerInput {\n  flex: 1 1 auto;\n  resize: none;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--ink);\n  outline: none;\n}\n.composerInput:focus { border-color: var(--red); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }\n.sendBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: none;\n  background: var(--red);\n  color: #fff;\n  border-radius: 12px;\n  padding: 11px 18px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  flex: 0 0 auto;\n}\n.sendBtn:hover { background: var(--red-d); }\n.sendBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n.sendBtn svg { width: 18px; height: 18px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thread": `ProjectThread-thread-lGPhN`,
	"head": `ProjectThread-head-XGv73`,
	"backBtn": `ProjectThread-backBtn-DDKHg`,
	"headMain": `ProjectThread-headMain-xFUN5`,
	"headAvatar": `ProjectThread-headAvatar-pP7j1`,
	"headName": `ProjectThread-headName-mgSG7`,
	"headProject": `ProjectThread-headProject-C04G1`,
	"safetyNote": `ProjectThread-safetyNote-_p5G8`,
	"list": `ProjectThread-list-cl2UP`,
	"loading": `ProjectThread-loading-hwvZf`,
	"emptyMsg": `ProjectThread-emptyMsg-KXaCk`,
	"emptyMsgSub": `ProjectThread-emptyMsgSub-LMi9s`,
	"row": `ProjectThread-row-RxLW1`,
	"rowMine": `ProjectThread-rowMine-KxqzK`,
	"rowTheirs": `ProjectThread-rowTheirs-yWz9q`,
	"bubble": `ProjectThread-bubble-EK07m`,
	"bubbleMine": `ProjectThread-bubbleMine-NWYiy`,
	"bubbleTheirs": `ProjectThread-bubbleTheirs-O7xyq`,
	"bubbleText": `ProjectThread-bubbleText-w7lbS`,
	"bubbleTime": `ProjectThread-bubbleTime-vukcZ`,
	"filteredNote": `ProjectThread-filteredNote-ovV9C`,
	"alertErr": `ProjectThread-alertErr-0wzSo`,
	"composer": `ProjectThread-composer-eLQjb`,
	"composerInput": `ProjectThread-composerInput-gtv9Y`,
	"sendBtn": `ProjectThread-sendBtn-cvxdN`
};
module.exports = ___CSS_LOADER_EXPORT___;
